import React, { useEffect, useState } from "react";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { MainContainer } from "../content/content.element";
import {
  Box,
  Button,
  Grid,
  InputAdornment,
  TextField,
  Typography
} from "@mui/material";
import EnquiryTable from "./EnquiryTable";
import { RiSearch2Line } from "react-icons/ri";
import { makeStyles } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import {
  enquirySearchFindAction,
  enquiryStudentDetailsFilterAction,
  enquiryStudentDetailsFindAction,
  enquiryStudentDetailsWithoutPaginationFindAction
} from "../../actions/enquiryAction";
import { useNavigate } from "react-router-dom";
import TableNoItemComponent from "../customComponent/TableNoItemComponent";
import EnquiryFilter from "./EnquiryFilter"
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  searchContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1),
    position: "relative"
  },
  searchInput: {
    marginLeft: theme.spacing(1)
  }
}));
function EnquiryMain({ toggle }) {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [paginationPageNumber, setPaginationPageNumber] = useState(1);
  const [pagiantionEntry, setPagiantionEntry] = useState(10);
  const [counsilorNote, setCounsilorNote] = useState({});
  const [teleCallerNote, setTeleCallerNote] = useState({});

  let { enquiryStudentDetailsSuccess, enquiryStudentDetailsLoading } =
    useSelector((state) => state.enquiryStudentDetails);

  const { enquiryStudentDetailsWithoutPaginationSuccess } = useSelector((state) => state.enquiryStudentDetailsWithoutPagination)
  const { enquiryStudentDetailsFilterSuccess } = useSelector((state) => state.enquiryStudentDetailsFilter)

  useEffect(() => {
    dispatch(enquiryStudentDetailsFindAction(paginationPageNumber));
    dispatch(enquiryStudentDetailsWithoutPaginationFindAction())
  }, [dispatch, paginationPageNumber]);

  useEffect(() => {
    if (enquiryStudentDetailsFilterSuccess) {
      setData(enquiryStudentDetailsFilterSuccess?.data);
      setPagiantionEntry(enquiryStudentDetailsFilterSuccess?.totalItems);

      const latestTeleCallerNote = enquiryStudentDetailsFilterSuccess?.data?.reduce(
        (latest, current) => {
          // Check if the current object has telecaller notes
          if (
            current.lead_telecaller_notes &&
            current.lead_telecaller_notes.length > 0
          ) {
            // Find the latest note in the current object's telecaller notes
            const latestInCurrent = current.lead_telecaller_notes.reduce(
              (latestNote, currentNote) =>
                new Date(currentNote.createdAt) > new Date(latestNote.createdAt)
                  ? currentNote
                  : latestNote,
              current.lead_telecaller_notes[0]
            );

            // Compare with the overall latest note
            return new Date(latestInCurrent.createdAt) >
              new Date(latest.createdAt)
              ? latestInCurrent
              : latest;
          }

          return latest;
        },
        { createdAt: "1970-01-01T00:00:00.000Z" }
      ); // Start with a very old date

      const latestCounsilorNote = enquiryStudentDetailsFilterSuccess?.data?.reduce(
        (latest, current) => {
          // Check if the current object has telecaller notes
          if (
            current.lead_counsilor_notes &&
            current.lead_counsilor_notes.length > 0
          ) {
            // Find the latest note in the current object's telecaller notes
            const latestInCurrent = current.lead_counsilor_notes.reduce(
              (latestNote, currentNote) =>
                new Date(currentNote.createdAt) > new Date(latestNote.createdAt)
                  ? currentNote
                  : latestNote,
              current.lead_counsilor_notes[0]
            );

            // Compare with the overall latest note
            return new Date(latestInCurrent.createdAt) >
              new Date(latest.createdAt)
              ? latestInCurrent
              : latest;
          }

          return latest;
        },
        { createdAt: "1970-01-01T00:00:00.000Z" }
      ); // Start with a very old date

      setCounsilorNote(latestCounsilorNote);
      setTeleCallerNote(latestTeleCallerNote);
    }
  }, [enquiryStudentDetailsFilterSuccess, paginationPageNumber]);

  useEffect(() => {
    if (enquiryStudentDetailsSuccess) {
      setData(enquiryStudentDetailsSuccess?.data);
      setPagiantionEntry(enquiryStudentDetailsSuccess?.totalItems);

      const latestTeleCallerNote = enquiryStudentDetailsSuccess?.data?.reduce(
        (latest, current) => {
          // Check if the current object has telecaller notes
          if (
            current.lead_telecaller_notes &&
            current.lead_telecaller_notes.length > 0
          ) {
            // Find the latest note in the current object's telecaller notes
            const latestInCurrent = current.lead_telecaller_notes.reduce(
              (latestNote, currentNote) =>
                new Date(currentNote.createdAt) > new Date(latestNote.createdAt)
                  ? currentNote
                  : latestNote,
              current.lead_telecaller_notes[0]
            );

            // Compare with the overall latest note
            return new Date(latestInCurrent.createdAt) >
              new Date(latest.createdAt)
              ? latestInCurrent
              : latest;
          }

          return latest;
        },
        { createdAt: "1970-01-01T00:00:00.000Z" }
      ); // Start with a very old date

      const latestCounsilorNote = enquiryStudentDetailsSuccess?.data?.reduce(
        (latest, current) => {
          // Check if the current object has telecaller notes
          if (
            current.lead_counsilor_notes &&
            current.lead_counsilor_notes.length > 0
          ) {
            // Find the latest note in the current object's telecaller notes
            const latestInCurrent = current.lead_counsilor_notes.reduce(
              (latestNote, currentNote) =>
                new Date(currentNote.createdAt) > new Date(latestNote.createdAt)
                  ? currentNote
                  : latestNote,
              current.lead_counsilor_notes[0]
            );

            // Compare with the overall latest note
            return new Date(latestInCurrent.createdAt) >
              new Date(latest.createdAt)
              ? latestInCurrent
              : latest;
          }

          return latest;
        },
        { createdAt: "1970-01-01T00:00:00.000Z" }
      ); // Start with a very old date

      setCounsilorNote(latestCounsilorNote);
      setTeleCallerNote(latestTeleCallerNote);
    }
  }, [enquiryStudentDetailsSuccess, paginationPageNumber]);

  // pagination

  const handleChangePage = (event, newPage) => {
    setPaginationPageNumber(newPage);
  };

  const searchHandleChange = (event) => {
    try {
      const newSearchValue = event.target.value.trim();
      fetchSearchResults(newSearchValue, paginationPageNumber);
    } catch (error) {
      console.error(error);
    }
  }

  const fetchSearchResults = async (value, pageNumber) => {
    try {
      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let UserId = isUserExist?.UserId;

      let { data } = await axios.get(
        `/api/admin/enquiry/studentdetailssearch?pageNumber=${pageNumber}&q=${value}`,
        config
      );

      setData(data?.data);

    } catch (error) {
      console.error(error);
    }
  }

  const leadFilterFunction = (filterData) => {
    try {
      dispatch(enquiryStudentDetailsFilterAction(paginationPageNumber, filterData))
    } catch (error) {
      console.error(error);
    }
  }

  const columns = [
    {
      title: "Sl no",
      field: "sl"
    },
    {
      title: "Name",
      field: "name"
    },
    {
      title: "Email",
      field: "email"
    },
    {
      title: "Phone",
      field: "phone"
    },

    {
      title: "Whatsapp Number",
      field: "whatsappNumber"
    },
    {
      title: "Passport number",
      field: "passportNumber"
    },
    {
      title: "Country",
      field: "preferredCountry"
    },
    {
      title: "Lead Source",
      field: "leadSource"
    },
    {
      title: "Lead Owner",
      field: "leadOwner"
    },
    {
      title: "Counsilor",
      field: "counsilor"
    },
    {
      title: "Counsilor note",
      field: "counsilorNote"
    },
    {
      title: "TeleCaller",
      field: "TeleCaller"
    },
    {
      title: "Telecaller note",
      field: "telecallerNote"
    },
    {
      title: "Lead Branch",
      field: "leadBranch"
    },
    {
      title: "Conversion Status",
      field: "status"
    },
    {
      title: "Lead Status",
      field: "Lead Status"
    },
    // {
    //   title: "Application status",
    //   field: "applicationstatus",
    // },
    {
      title: "Action",
      field: "action"
    }
  ];

  return (
    <MainContainer active={toggle}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          mb: 3
        }}
      >
        <KeyboardBackspaceIcon
          onClick={() => navigate("/")}
          sx={{ cursor: "pointer" }}
        />
        <Typography
          sx={{
            color: "#05050F",
            fontSize: "22px",
            fontWeight: "700"
          }}
        >
          Total Search
        </Typography>
      </Box>

      <Box sx={{ width: "100%" }}>
        {/* Search Bar */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            mb: 3
          }}
        >
          <Grid>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                const syntheticEvent = {
                  target: {
                    value: searchText
                  }
                };
                searchHandleChange(syntheticEvent);
              }}
            >
              <div className={classes.searchContainer}>
                <TextField
                  className={classes.searchInput}
                  variant="outlined"
                  placeholder="Search Here"
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    // searchHandleChange(e);
                    // handleSearchChange(e)
                  }}
                  sx={{
                    "& .MuiInputBase-input": {
                      borderRadius: "20px",
                      height: "1px",
                      paddingRight: "48px !important"
                    },
                    "& .MuiFormLabel-root": {
                      lineHeight: "5px"
                    },

                    "& .MuiInputBase-root": {
                      borderRadius: "3px",
                      borderColor: "#fafafa"
                    },
                    "& .MuiOutlinedInput-notchedOutline ": {
                      borderRadius: "3px",
                      borderColor: "#ECECEC !important",
                      borderWidth: "1px !important"
                    }
                  }}
                />
                <>
                  <InputAdornment
                    position="end"
                    sx={{
                      position: "absolute",
                      right: "8px",
                      width: "40px",
                      // top:"0",
                      // bottom:"0",
                      border: "1px solid #ECECEC",
                      borderRadius: "3px",
                      height: "34px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer"
                    }}
                  >
                    <button type="submit" style={{
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '100%',
                      height: '100%'
                    }}>
                      <RiSearch2Line />
                    </button>
                  </InputAdornment>
                </>
              </div>
            </form>
          </Grid>
        </Box>

        {/* Main Content Grid */}
        <Grid container spacing={2}>
          {/* Filter Section */}
          <Grid item xs={12} md={2} lg={2.2}>
            <EnquiryFilter
              leadFilterFunction={leadFilterFunction}
              data={enquiryStudentDetailsWithoutPaginationSuccess?.data}
            />
          </Grid>

          {/* Table Section */}
          <Grid item xs={12} md={10} lg={9.8}>
            {data.length > 0 ? (
              <EnquiryTable
                columns={columns}
                data={data}
                paginationPageNumber={paginationPageNumber}
                pagiantionEntry={pagiantionEntry}
                handlePageNation={handleChangePage}
                totalEntry={pagiantionEntry}
                teleCallerNote={teleCallerNote}
                counsilorNote={counsilorNote}
              />
            ) : (
              <TableNoItemComponent />
            )}
          </Grid>
        </Grid>
      </Box>
    </MainContainer>
  );
}

export default EnquiryMain;
